import { LoginPanel } from "../../inJoy-components/LoginPanel/LoginPanel";

const LoginPage = () => {
	// OAuth Google Login handler
	const handleGoogleLogin = () => {
		window.location.href = `${import.meta.env.VITE_APP_API_URL}/login`;
	};

	return (
		<LoginPanel
			logoSrc={`${import.meta.env.VITE_APP_WEBSITE_URL}/img/logo_word_color.svg`}
			title="Login to inJOY Event"
			subtitle="For venue teams managing sport events and reservations."
			backgroundImage={`${import.meta.env.VITE_APP_WEBSITE_URL}/img/login_bg.png`}
			onGoogleLogin={handleGoogleLogin}
			language="English"
			onLanguageChange={() => undefined}
			loading={false}
		/>
	);
};

export { LoginPage };
